module.exports = __webpack_public_path__ + "media/images/official/about_point2-a28b9df4bf7eba718e860ebdccc632c1.jpg";